import { render, staticRenderFns } from "./RecipeCard.vue?vue&type=template&id=5cc24e24&scoped=true&"
import script from "./RecipeCard.vue?vue&type=script&lang=js&"
export * from "./RecipeCard.vue?vue&type=script&lang=js&"
import style0 from "./RecipeCard.vue?vue&type=style&index=0&id=5cc24e24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc24e24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cookbook/cookbook/cookbook/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cc24e24')) {
      api.createRecord('5cc24e24', component.options)
    } else {
      api.reload('5cc24e24', component.options)
    }
    module.hot.accept("./RecipeCard.vue?vue&type=template&id=5cc24e24&scoped=true&", function () {
      api.rerender('5cc24e24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RecipeCard.vue"
export default component.exports